<template>
  <div class="app_container">
    <search
      showDept
      class="search-wrapper"
      @search="searchHandle"
      @setGraduationStatusData="setGraduationStatusData"
      :isParty="String(isParty)"
      :smallClassNameList="smallClassNameList"
      :childNum="childNum"
      :onlineLearn="onlineLearn"
    />
    <div class="handle_wrapper">
      <butn
        v-permission="'classOffline:saveStudent'"
        btntype="primary"
        title="添加学员"
        @click="saveEnrollManage"
      ></butn>
      <butn
        v-permission="'classOffline:saveStudent'"
        btntype="primary"
        title="移动学员"
        @click="moveMembers"
        v-if="trainTypeName === '轮训班'"
      ></butn>
      <ExcelImport
        class="m-l-10"
        butnPremission="classOffline:importEnroll"
        butnTitle="导入"
        modalTitle="学员导入"
        :downloadTemplate="importTemplate"
        :importApi="importApi"
        :classId="classId"
        @importSuccess="importSuccess"
      />
      <butn
        class="m-l-10"
        v-permission="'classOffline:exportEnroll'"
        btntype="primary"
        title="导出"
        @click="exportExcel"
        :disabled="questionList && questionList.length === 0"
      ></butn>
      <drop-down
        v-if="checkArray.length === 0 && batchData.length > 0"
        class="dropdown dropdown-disable m-r-10"
        title="批量操作"
        @select="handle"
      />
      <drop-down
        v-else-if="checkArray.length > 0 && batchData.length > 0"
        class="dropdown m-r-10"
        title="批量操作"
        :data="batchData"
        @select="handle"
      />
      <butn
        v-permission="'classOffline:switchUnitPosition'"
        btntype="primary"
        title="单位及职务切换"
        @click="postSwitch"
        :disabled="classStatus == 4"
      ></butn>
      <butn
        v-permission="'classOffline:oneClickCheck'"
        btntype="primary"
        title="一键检查"
        :loading="oneCheckLoading"
        @click="oneCheck"
      ></butn>
    </div>
    <Table
      @selection-change="selectChange"
      :data="questionList"
      row-key="uuid"
      :isAttachment="isAttachment"
      :isParty="isParty"
      :onlineLearn="onlineLearn"
      @edit="edit"
      :childNum="childNum"
      @editMemberInfo="editMemberInfo"
      @goDetail="goDetail"
      @updateGraduateInfo="updateGraduateInfo"
      @outSchoolDetail="outSchoolDetail"
      @updatePost="showPostDialog"
    />
    <div class="RCPagination">
      <butn
        style="float: left"
        btntype="primary"
        iconName="el-icon-arrow-left"
        title="返回"
        @click="$router.push({path: '/offlineClass'})"
      ></butn>
      <RCPagination
        ref="pagination"
        :startRequest="false"
        v-model="questionList"
        :api="api"
      />
    </div>
    <MemberSelect />
    <UpdatePost 
      :postDialog="postDialog" 
      v-if="postDialog.flag"
      @closeDialog="closePostDialog"
      :lObject="lObject"
    />
    <SelectStudents
      :studentDialog="studentDialog"
      :classId="classId"
      @closeSelect="closeSelect"
      v-if="studentDialog.show"
      :isOffline="true"
      :needDisable="true"
      :showIsExam="true"
    />
    <MoveMember
      :moveMemberDialog="moveMemberDialog"
      :classId="classId"
      v-if="moveMemberDialog.show"
      @requery="requery"
      @openSelctedTable="openSelctedTable"
      ref="MoveMember"
    />
    <InfoChange
      :dialogInfo="dialogInfo"
      :graduationStatusData="graduationStatusData"
      @close="close"
      v-if="dialogInfo.show"
    />
    <UpdateMember
      :memberDialogInfo="memberDialogInfo"
      @closeEditMember="closeEditMember"
      v-if="memberDialogInfo.show"
    />
    <ChangeGraduateInfo
      :dialogInfo="graduateDialogInfo"
      :nowRow="nowRow"
      @close="closeGraduate"
      :graduateTypeList="graduateTypeList"
      v-if="graduateDialogInfo.show"
    />
    <OutSchoolInfo
      :dialogInfo="outSchoolDialogInfo"
      @close="closeOutSchool"
      v-if="outSchoolDialogInfo.show"
    />
    <SelectTable
      v-if="selctedTableInfo.show"
      :selctedTableInfo="selctedTableInfo"
      :groupNameList="classes.slice(1)"
      @closeDia="closeDia"
      @sureMove="sureMove"
    />
    <PostSwitch
      :dialogInfo="postSwitchDialog"
      @close="closePostSwitchDialog"
      v-if="postSwitchDialog.show"
    />
    <OneCheck
      :dialogInfo="oneCheckDialog"
      @close="closeOneCheckDialog"
      v-if="oneCheckDialog.show"
    />
  </div>
</template>

<script>
import {
batchDownload, cancelExcellent, cancelGraduation, deletePost, deleteStudent,
exportEnroll, getPageStudent, graduation, setExcellent,
updateTrainDays, importEnroll, moveStudent, classOneClickCheck
} from "@/api/enrollOffline";
import { smallClassName } from "@/api/groupManage";
import butn from "@/components/button/index";
import { Confirm } from "@/components/Confirm";
import DropDown from "@/components/dropDown/index";
import RCPagination from "@/components/pagination/paginationManage";
import vue from "@/main";
import store from "@/store";
import { getEnums } from "@/utils/common.js";
import InfoChange from "@/views/offlineClass/students/infoChange.vue";
import MoveMember from "@/views/offlineClass/students/moveMember.vue";
import ChangeGraduateInfo from "@/views/offlineClass/transferStudents/sureMember/changeGraduateInfo.vue";
import OutSchoolInfo from "@/views/offlineClass/transferStudents/sureMember/outSchoolInfo.vue";
import SelectStudents from "@/views/onlineClass/students/selectStudents.vue";
import MemberSelect from "./memberSelect";
import Search from "./search";
import Table from "./table.js";
import UpdateMember from "./updateMember.vue";
import UpdatePost from "./updatePost";
import ExcelImport from "@/components/exceImport";
import { studentsTemplate } from "@/assets/excel/index.js";
import SelectTable from "@/views/offlineClass/students/selectTable.vue";
import PostSwitch from "./postSwitch.vue";
import OneCheck from "./oneCheck.vue";

export default {
  name: "offlineClassStudents",
  components: {
    Table,
    Search,
    butn,
    RCPagination,
    MemberSelect,
    DropDown,
    UpdatePost,
    SelectStudents,
    MoveMember,
    InfoChange,
    UpdateMember,
    ChangeGraduateInfo,
    OutSchoolInfo,
    ExcelImport,
    SelectTable,
    PostSwitch, 
    OneCheck,
  },
  data() {
    let batchData = [];
    // 针对上级路由onlineClass
    const permissionList = store.getters.permissionList["offlineClass"];
    const isParty = this.$route.query.isParty;
    const isAttachment = this.$route.query.isAttachment;
    const onlineLearn = this.$route.query.onlineLearn;
    if (
      permissionList &&
      permissionList.includes("classOffline:deleteStudent")
    ) {
      batchData.push({ paramValue: "批量移除", paramKey: "1" });
    }
    if (permissionList && permissionList.includes("classOffline:graduation")) {
      batchData.push({ paramValue: "批量结业", paramKey: "2" });
      batchData.push({ paramValue: "批量取消结业", paramKey: "3" });
    }
    if (permissionList && permissionList.includes("classOffline:excellent")) {
      batchData.push({ paramValue: "批量设置优秀学员", paramKey: "4" });
      batchData.push({ paramValue: "批量取消优秀学员", paramKey: "5" });
    }
    if (
      permissionList &&
      permissionList.includes("classOffline:downloadBatch")
    ) {
      batchData.push({ paramValue: "批量下载附件", paramKey: "6" });
    }
    return {
      selctedTableInfo: {
        show: false,
      },
      classes: [],
      ids: [],
      classParentId: "",
      memberDialogInfo: {
        show: false,
        member: {},
      },
      questionList: [],
      api: getPageStudent,
      checkArray: [],
      dataname: "",
      delFlag: true,
      batchData,
      isParty,
      isAttachment,
      onlineLearn,
      studentDialog: {
        show: false,
      },
      classId: "",
      deptTreeData: [],
      moveMemberDialog: {
        show: false,
      },
      dialogInfo: {
        show: false,
        type: 1,
        title: "",
        uuid: "",
        days: 0,
        graduationStatus: null,
      },
      graduationStatusData: [],
      trainTypeName: "",
      smallClassNameList: [],
      childNum: 0,
      nowRow: {},
      graduateDialogInfo: {
        show: false,
        member: {},
      },
      graduateTypeList: [],
      outSchoolDialogInfo: {
        show: false,
        row: {},
      },
      postDialog: {
        flag: false
      },
      lObject: {
        uuid: "",
        classPost: ""
      },
      importApi: importEnroll,
      importTemplate: studentsTemplate,
      oneCheckLoading: false,
      postSwitchDialog: {show: false},
      oneCheckDialog: {show: false},
      classStatus: null,
    };
  },
  created() {
    getEnums(["CLASS_FINISH_STATUS"], this, ["graduateTypeList"], [false]);
    let { trainTypeName, id, childNum, status=null } = this.$route.query;
    this.trainTypeName = trainTypeName;
    this.classId = id;
    this.childNum = Number(childNum);
    this.classStatus = status
    // this.isAttachment = this.$route.query.isAttachment;
    this.$nextTick(() => {
      this.searchHandle({});
    });
    const _this = this;
    vue.$on("tableInit", () => {
      _this.searchHandle({});
    });
    vue.$on("deleteStudent", (item) => {
      _this.deleteStudent([item.uuid]);
    });

    vue.$on("deletePost", (item) => {
      _this.deletePost([item.uuid]);
    });
    vue.$on("sendGraduation", (uuid) => {
      _this.graduation([uuid]);
    });
    vue.$on("cancelGraduation", (uuid) => {
      _this.cancelGraduation([uuid]);
    });
    vue.$on("setExcellent", (uuid) => {
      _this.setExcellent([uuid]);
    });
    vue.$on("cancelExcellent", (uuid) => {
      _this.cancelExcellent([uuid]);
    });
    vue.$on("downloadUserFile", (item) => {
      _this.downloadData(item);
    });
    if (this.childNum > 0) {
      smallClassName({ classId: this.classId }).then(({ code, data }) => {
        if (code !== 0) return;
        this.smallClassNameList = [
          { paramKey: "", paramValue: "全部" },
          ...data,
        ];
      });
    }
  },
  methods: {
    openSelctedTable(params) {
      this.selctedTableInfo.show = true;
      this.ids = params.ids;
      this.classes = params.classes;
    },
    closeDia() {
      this.selctedTableInfo.show = false;
    },
    sureMove(row) {
      const _this = this;
      moveStudent({ classId: row.uuid, userIdList: _this.ids }).then(
        ({ code }) => {
          if (code !== 0) return;
          _this.selctedTableInfo.show = false;
          _this.$refs.MoveMember.moveEndRefresh();
          _this.$refs["pagination"].reload(_this.dataname);
        }
      );
    },
    importSuccess() {
      this.$refs["pagination"].search(this.dataname);
    },
    closeOutSchool() {
      this.outSchoolDialogInfo.show = false;
    },
     outSchoolDetail(row) {
      this.outSchoolDialogInfo.row = row;
      this.outSchoolDialogInfo.show = true;
    },
    closeGraduate(flag, params = {}) {
      if (flag) {
        updateTrainDays({ ...params }).then(({ code, msg }) => {
          if (code !== 0) return;
          this.requery();
          this.$message({
            type: "success",
            message: msg,
          });
          this.graduateDialogInfo.show = false;
        });
      } else {
        this.graduateDialogInfo.show = false;
      }
    },
    updateGraduateInfo(row) {
      this.nowRow = row;
      this.graduateDialogInfo.member = row;
      this.graduateDialogInfo.show = true;
    },
    goDetail(row) {
      const { userId: id } = row;
      this.$router.push({
        path: "/user/detail",
        query: { id, status: true },
      });
    },
    closeEditMember(flag) {
      if (flag) {
        this.requery();
      }
      this.memberDialogInfo.show = false;
    },
    editMemberInfo(item) {
      this.memberDialogInfo.member = item;
      this.memberDialogInfo.show = true;
    },
    requery() {
      this.$refs["pagination"].reload(this.dataname);
    },
    close(flag) {
      this.dialogInfo.show = false;
      if (flag) {
        this.$refs["pagination"].search(this.dataname);
      }
    },
    setGraduationStatusData(val) {
      this.graduationStatusData = val;
    },
    edit(row, type, title) {
      this.dialogInfo = {
        show: true,
        type,
        title,
        uuid: row.uuid,
        days: row.trainDays,
        graduationStatus: row.graduationStatus,
      };
    },
    moveMembers() {
      this.moveMemberDialog.show = true;
    },
    closeSelect(flag) {
      this.studentDialog = {
        show: false,
      };
      if (flag) {
        this.searchHandle();
      }
    },
    // 搜索
    searchHandle(params) {
      // params.classId = this.$route.query.id;
      this.dataname = Object.assign({}, { ...params, classId: this.classId });
      this.$refs["pagination"].search(this.dataname);
    },
    selectChange(selections) {
      this.checkArray = selections;
      if (selections.length > 0) {
        this.delFlag = false;
      } else {
        this.delFlag = true;
      }
    },
    // 学员管理
    saveEnrollManage() {
      this.studentDialog = {
        show: true,
      };
      // treeDeptForClass(this.classId).then(({ code, data }) => {
      //   if (code !== 0) return;
      //   this.deptTreeData = data;
      //   this.studentDialog = {
      //     show: true,
      //   };
      // });
    },
    // 导入
    importExcel() {
      this.importDialog.flag = true;
    },
    // 修改班内职务
    showPostDialog(item) {
      this.lObject.uuid = item.uuid;
      if (item.classPostName.indexOf('组长') != -1) {
        this.lObject.classPost = item.classPostName;
      } else {
        this.lObject.classPost = item.classPost;
      }
      this.postDialog.flag = true;
    },
    // 关闭班内职务弹窗
    closePostDialog(flag) {
      this.postDialog = {
        flag: false,
      };
      if (flag) {
        this.searchHandle();
      }
    },
    // 导出
    exportExcel() {
      exportEnroll({...this.dataname, isRelevanceZwy: this.onlineLearn }).then((response) => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function () {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error",
              });
            }
          } catch (e) {
            let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
        // 更新列表
        this.$refs["pagination"].search(this.dataname);
      });
    },
    // 删除学员
    async deleteStudent(params) {
      try {
        await Confirm(`确认删除该学员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        deleteStudent({ uuids: params }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.$refs["pagination"].search(this.dataname);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 删除班委学员
    async deletePost(params) {
      try {
        await Confirm(`确认将该学员从班委移除吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        deletePost({ uuids: params }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.$refs["pagination"].search(this.dataname);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 取消结业
    async cancelGraduation(params) {
      try {
        await Confirm(`确认取消结业吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        cancelGraduation({ uuids: params }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$refs["pagination"].search(this.dataname);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 批量结业
    async graduation(uuid) {
      try {
        await Confirm("确认结业吗？", "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        let params = {};
        params["uuids"] = uuid;
        graduation(params).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$refs["pagination"].search(this.dataname);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    // 设置优秀学员
    async setExcellent(params) {
      try {
        await Confirm(`确认设置优秀学员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        setExcellent({ uuids: params }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$refs["pagination"].search(this.dataname);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    async cancelExcellent(params) {
      try {
        await Confirm(`确认取消优秀学员吗？`, "系统提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "warning",
        });
        cancelExcellent({ uuids: params }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.$refs["pagination"].search(this.dataname);
        });
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    handle(command) {
      if (command.paramValue === "批量移除") {
        this.$confirm(`确认批量移除选中的学员吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            deleteStudent({ uuids: this.userIds }).then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 更新列表
                this.$refs["pagination"].search(this.dataname);
              }
            });
          })
          .catch(() => {});
      } else if (command.paramValue === "批量结业") {
        if (this.checkArray.some(({graduationStatus})=>graduationStatus==2)) {
          this.$message({
            type: "error",
            message: "存在退学状态数据，请取消选中后重试～",
          });
          return;
        };
        this.$confirm(`确认批量结业吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            graduation({
              uuids: this.userIds,
            }).then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 更新列表
                this.$refs["pagination"].search(this.dataname);
              }
            });
          })
          .catch(() => {});
      } else if (command.paramValue === "批量取消结业") {
        this.$confirm(`确认批量取消结业吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            cancelGraduation({
              uuids: this.userIds,
            }).then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 更新列表
                this.$refs["pagination"].search(this.dataname);
              }
            });
          })
          .catch(() => {});
      } else if (command.paramValue === "批量设置优秀学员") {
        this.$confirm(`确定批量设置优秀学员吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            setExcellent({
              uuids: this.userIds,
            }).then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 更新列表
                this.$refs["pagination"].search(this.dataname);
              }
            });
          })
          .catch(() => {});
      } else if (command.paramValue === "批量取消优秀学员") {
        this.$confirm(`确定批量取消优秀学员吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            cancelExcellent({
              uuids: this.userIds,
            }).then((res) => {
              if (res && res.code == 0) {
                this.$message.success(res.msg);
                // 更新列表
                this.$refs["pagination"].search(this.dataname);
              }
            });
          })
          .catch(() => {});
      } else if (command.paramValue === "批量下载附件") {
        this.$confirm(`确定批量下载附件吗？`, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.batchDowndload();
          })
          .catch(() => {});
      }
    },
    batchDowndload() {
      batchDownload({
        uuids: this.userIds,
        status: 1,
      }).then((response) => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function () {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error",
              });
            }
          } catch (e) {
            let blob = new Blob([response.data]); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
        // 更新列表
        this.$refs["pagination"].search(this.dataname);
      });
    },
    //附件下载
    downloadData(item) {
      let a = document.createElement("a"); //创建一个<a></a>标签
      let attachment = JSON.parse(item.attachment);
      a.href = attachment[0].url;
      a.download = item.attachmentName;
      a.style.display = "none";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); // 下载完成移除元素
    },

    postSwitch() {
      this.postSwitchDialog = {
        show: true,
        classId: this.classId,
      }
    },
    closePostSwitchDialog(flag) {
      this.postSwitchDialog = {
        show: false,
      }
      if (flag) {
        this.$refs["pagination"].reload(this.dataname);
      }
    },
    oneCheck() {
      this.oneCheckLoading = true
      const loading = this.$loading({
        lock: true,
        text: '正在检查中，请勿离开当前页面',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      classOneClickCheck({ uuid: this.classId }).then(({code, data = []}) => {
        if (code == 0 ) {
          // 判断data 是不是数组，是否为空数组，有数据才进行下一步
          if (Array.isArray(data) && data.length > 0) { 
            this.oneCheckDialog = {
              show: true,
              list: data
            }
          }
        }
        this.oneCheckLoading = false
        loading.close()
      }).catch((err) => { 
        this.oneCheckLoading = false
        loading.close()
      })
    },
    closeOneCheckDialog() {
      this.oneCheckDialog = {
        show: false,
      }
    },
  },
  computed: {
    userIds() {
      return this.checkArray.map((item) => item.uuid);
    },
  },
  beforeDestroy() {
    vue.$off("deleteStudent");
    vue.$off("tableInit");
  },
};
</script>

<style lang="scss" scoped>
.search-wrapper {
  float: right;
}
.handle-wrapper {
  float: left;
}
.m-r-10 {
  margin-right: 10px;
}
</style>
